// store.js
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import scheduleReducer from './reducer'; // Import the reducer from above

// Configure the DevTools with the unique name
const composeEnhancers = composeWithDevTools({ 
  name: 'ScheduleInspections', 
  trace: true
});

export const store = createStore(
  scheduleReducer,
  composeEnhancers(applyMiddleware(thunk))
);